import { CircularProgress } from '@mui/material';
import { GridActionsCellItem, GridOverlay } from '@mui/x-data-grid';
import { Edit, Delete } from '@mui/icons-material';

// CONSTANTE ZA STUDENTE

export const LoadingOverlay = () => (
  <GridOverlay>
    <CircularProgress />
  </GridOverlay>
);

export const studentColumns = (
  t,
  categories,
  handleDialogToggle,
  handleConfirmDeleteToggle
) => [
  { field: 'id', headerName: t('columns.id'), width: 90 },
  { field: 'name', headerName: t('columns.name'), width: 200 },
  { field: 'gender', headerName: t('columns.gender'), width: 100 },
  {
    field: 'category',
    headerName: t('columns.category'),
    width: 150,
    valueGetter: (params) =>
      categories[params.row.category] || params.row.category
  },
  { field: 'class', headerName: t('columns.class'), width: 100 },
  { field: 'professor', headerName: t('columns.professor'), width: 200 },
  { field: 'language', headerName: t('columns.language'), width: 150 },
  { field: 'school_name', headerName: t('columns.schoolName'), width: 200 },
  { field: 'city_name', headerName: t('columns.cityName'), width: 200 },
  {
    field: 'actions',
    type: 'actions',
    headerName: t('columns.actions'),
    width: 150,
    getActions: (params) => [
      <GridActionsCellItem
        icon={<Edit sx={{ color: '#1c75bc', fontSize: '24px' }} />}
        label="Edit"
        onClick={() => handleDialogToggle(true, params.row)}
      />,
      <GridActionsCellItem
        icon={<Delete sx={{ color: '#e91e63', fontSize: '24px' }} />}
        label="Delete"
        onClick={() => handleConfirmDeleteToggle(true, params.row)}
      />
    ]
  }
];

const decodeUnicode = (str) => {
  return str.replace(/\\u[\dA-F]{4}/gi, (match) =>
    String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
  );
};

export const mapStudents = (students) => {
  return students.map((student) => ({
    ...student,
    name: decodeUnicode(student.name),
    professor: decodeUnicode(student.professor),
    gender: decodeUnicode(student.pol) === 'm' ? 'Мушки' : 'Женски',
    language: decodeUnicode(student.language)
  }));
};
